module.exports = __webpack_public_path__ + "static/keyflow1-8b2566e53aa8d038de0e7d1cc6a3c119.png";